(() => {
	angular.module('main').directive('userNavbar', userNavbar);

	userNavbar.$inject = ['userService', 'accountService'];

	function userNavbar(userService, accountService) {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./userNavbar.component.html'),
			link(scope) {
				scope.user = userService.userData;

				$('.keep-open').on('click', e => {
					e.stopPropagation();
				});

				scope.logout = () => {
					accountService.logoutWeb();
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/user-navbar/userNavbar.component.js